import trackerRequest, {
  ClientErrorPayload,
  JourneyStepPayload,
} from 'src/api/requests/tracker'

export const JOURNEY_STEP = {
  REGISTRATION_STARTED: 'registration_started',
  REGISTRATION_COMPLETED: 'registration_completed',
  MENU_VIEWED: 'menu_viewed',
  MENU_SELECTED: 'menu_selected',
  QUESTIONNAIRE_STARTED: 'questionnaire_started',
  QUESTIONNAIRE_COMPLETED: 'questionnaire_completed',
  IMAGE_UPLOADED: 'image_uploaded',
  PROPOSAL_VIEWED: 'proposal_viewed',
  PLAN_VIEWED: 'plan_viewed',
  PLAN_SELECTED: 'plan_selected',
  IDENTIFICATION_STARTED: 'identification_started',
  ADDRESS_ENTERED: 'address_entered',
  SMS_VERIFIED: 'sms_verified',
  PAYMENT_STARTED: 'payment_started',
  PAYMENT_COMPLETED: 'payment_completed',
} as const

export type JourneyStepValue = typeof JOURNEY_STEP[keyof typeof JOURNEY_STEP]

/**
 * Fire-and-forget: records the current journey step.
 * Never throws — tracking failures must never break the user flow.
 */
export const trackStep = (
  step: JourneyStepValue,
  options: {
    userTreatmentId?: number | string | null
    metadata?: Record<string, unknown>
  } = {},
): void => {
  const payload: JourneyStepPayload = {
    step,
    user_treatment_id: options.userTreatmentId ?? null,
    metadata: options.metadata,
  }

  trackerRequest.recordStep(payload).catch(() => {
    // Intentionally silent — tracking must not break the user flow.
  })
}

/**
 * Fire-and-forget: logs a client-side error to the backend → CloudWatch.
 * Never throws.
 */
export const trackError = (payload: ClientErrorPayload): void => {
  trackerRequest.logError(payload).catch(() => {
    // Intentionally silent.
  })
}
